import * as tslib_1 from "tslib";
import { BaseSystemConfigurationValues } from "./base.system.configuration.manager";
import { map, share } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "./system.configuration.service";
/**
 Service class for getting system configuration from server after validity checks.
 */
var PreLoginSystemConfigurationValues = /** @class */ (function (_super) {
    tslib_1.__extends(PreLoginSystemConfigurationValues, _super);
    function PreLoginSystemConfigurationValues(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.preLoginCachedSysCfgObservable = cfg.getPreLoginSystemConfiguration().pipe(share());
        return _this;
    }
    PreLoginSystemConfigurationValues.prototype.GetCreateAccountEnabledAsync = function () {
        var _this = this;
        return this.preLoginCachedSysCfgObservable.pipe(map(function (sysCfg) {
            return _this.getBoolean('PP_CreateAccountEnabled');
        }));
    };
    Object.defineProperty(PreLoginSystemConfigurationValues.prototype, "CreateAccountEnabled", {
        get: function () {
            return this.getBoolean('PP_CreateAccountEnabled');
        },
        enumerable: true,
        configurable: true
    });
    PreLoginSystemConfigurationValues.prototype.GetCreateNewPatientOnAccountCreationEnabledAsync = function () {
        var _this = this;
        return this.preLoginCachedSysCfgObservable.pipe(map(function (sysCfg) {
            return _this.getBoolean('PP_CreateNewPatientOnAccountCreationEnabled');
        }));
    };
    Object.defineProperty(PreLoginSystemConfigurationValues.prototype, "CreateNewPatientOnAccountCreationEnabled", {
        get: function () {
            return this.getBoolean('PP_CreateNewPatientOnAccountCreationEnabled');
        },
        enumerable: true,
        configurable: true
    });
    PreLoginSystemConfigurationValues.prototype.GetUserPasswordPatternAsync = function () {
        var _this = this;
        return this.preLoginCachedSysCfgObservable.pipe(map(function (sysCfg) {
            return _this.getNumber('PP_UserPasswordPattern');
        }));
    };
    Object.defineProperty(PreLoginSystemConfigurationValues.prototype, "UserPasswordPattern", {
        get: function () {
            return this.getNumber('PP_UserPasswordPattern');
        },
        enumerable: true,
        configurable: true
    });
    PreLoginSystemConfigurationValues.prototype.GetUserPasswordLengthAsync = function () {
        var _this = this;
        return this.preLoginCachedSysCfgObservable.pipe(map(function (sysCfg) {
            return _this.getNumber('PP_UserPasswordLength');
        }));
    };
    Object.defineProperty(PreLoginSystemConfigurationValues.prototype, "UserPasswordLength", {
        get: function () {
            return this.getNumber('PP_UserPasswordLength');
        },
        enumerable: true,
        configurable: true
    });
    PreLoginSystemConfigurationValues.prototype.GetMainContactTelephoneAsync = function () {
        var _this = this;
        return this.preLoginCachedSysCfgObservable.pipe(map(function (sysCfg) {
            return _this.getValidatedString('PP_MainContactTelephone');
        }));
    };
    Object.defineProperty(PreLoginSystemConfigurationValues.prototype, "MainContactTelephone", {
        get: function () {
            return this.getValidatedString('PP_MainContactTelephone');
        },
        enumerable: true,
        configurable: true
    });
    PreLoginSystemConfigurationValues.prototype.GetLockExpirationTimeInMinutesAsync = function () {
        var _this = this;
        return this.preLoginCachedSysCfgObservable.pipe(map(function (sysCfg) {
            return _this.getNumber('PP_LockExpirationTimeInMinutes');
        }));
    };
    Object.defineProperty(PreLoginSystemConfigurationValues.prototype, "LockExpirationTimeInMinutes", {
        get: function () {
            return this.getNumber('PP_LockExpirationTimeInMinutes');
        },
        enumerable: true,
        configurable: true
    });
    PreLoginSystemConfigurationValues.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PreLoginSystemConfigurationValues_Factory() { return new PreLoginSystemConfigurationValues(i0.ɵɵinject(i1.SystemConfigurationService)); }, token: PreLoginSystemConfigurationValues, providedIn: "root" });
    return PreLoginSystemConfigurationValues;
}(BaseSystemConfigurationValues));
export { PreLoginSystemConfigurationValues };
